import { Component, Input } from '@angular/core';
import { GuestContactVO, ReservationVO, QuoteVO, OrderVO, TaskVO } from '../unified-inbox.models';

@Component({
    selector: 'app-guest-history-pane',
    templateUrl: './guest-history-pane.component.html',
    styleUrls: ['./guest-history-pane.component.scss'],
    standalone: false
})
export class GuestHistoryPaneComponent {
    @Input() contact: GuestContactVO;
    @Input() reservations: ReservationVO[] = [];
    @Input() quotes: QuoteVO[] = [];
    @Input() orders: OrderVO[] = [];
    @Input() tasks: TaskVO[] = [];

    resTagClass(res: ReservationVO): string {
        const map = {
            upcoming: 'res-upcoming',
            current: 'res-current',
            past: 'res-past',
            cancelled: 'res-cancelled'
        };
        return map[res.resStatus] || 'res-past';
    }

    resTagLabel(res: ReservationVO): string {
        return res.resStatus ? res.resStatus.charAt(0).toUpperCase() + res.resStatus.slice(1) : '';
    }

    statusDotClass(status: string): string {
        const s = status.toLowerCase();
        if (s === 'paid') { return 'dot-paid'; }
        if (s === 'pending') { return 'dot-pending'; }
        if (s === 'completed' || s === 'closed' || s === 'complete') { return 'dot-complete'; }
        return 'dot-open';
    }

    taskPriClass(priority: number): string {
        return `pri-${priority}`;
    }

    get initials(): string {
        if (!this.contact) { return '?'; }
        const f = this.contact.firstName ? this.contact.firstName.charAt(0) : '';
        const l = this.contact.lastName ? this.contact.lastName.charAt(0) : '';
        return (f + l).toUpperCase() || '?';
    }

    formatDate(val: string): string {
        if (!val) { return ''; }
        const d = new Date(val);
        if (isNaN(d.getTime())) { return val; }
        return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    }
}
